import { render, staticRenderFns } from "./login.component.html?vue&type=template&id=05433ff2&"
import script from "./login.component.ts?vue&type=script&lang=js&"
export * from "./login.component.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports